export enum StudentCountsInShapeColorByEnum {
  SCHOOL = "school",
  GRADE = "grade",
  NONE = "none",
}
